import { HttpResponse, SearchResponse } from "@/fetchInterceptor/AxiosMethod";
import { HttpClientNormal } from "@/fetchInterceptor/HttpClient";

import { AxiosResponse } from "axios";

import { config } from "../../config";
import { ISettingService } from "./ISettingService";
import { IFetchRequest, OrganizationEntity } from "./entity/OrganizationEntity";
import { SettingRequestModel } from "./entity/SettingRequestModel";
import { SettingResponseModel } from "./entity/SettingResponseModel";

export class SettingService implements ISettingService {
  private http: HttpClientNormal = new HttpClientNormal();

  addSettingOrganization(
    request: IFetchRequest,
    payload: SettingRequestModel
  ): Promise<SearchResponse<number>> {
    const url: string = `${config.API_URL}/${request.tenantId}/odata/Organizers('${request.orgId}')/Setting`;

    return this.http
      .post(url, payload)
      .then((response: AxiosResponse) => {
        return response.status;
      })
      .catch((error) => error?.response);
  }

  fetchOrganization(
    request: IFetchRequest,
    Keyword: string
  ): Promise<SearchResponse<OrganizationEntity>> {
    const url: string = `${config.API_URL}/${request.tenantId}/odata/Organizations('${request.orgId}')/AADUsers?$top=200&keyword=${Keyword}`;

    return this.http
      .get(url)
      .then((response: AxiosResponse) => {
        return new SearchResponse<OrganizationEntity>(
          response,
          OrganizationEntity
        );
      })
      .catch(
        (error) =>
          new SearchResponse<OrganizationEntity>(
            error?.response,
            OrganizationEntity
          )
      );
  }
  fetchSetting(
    request: IFetchRequest
  ): Promise<HttpResponse<SettingResponseModel>> {
    const url: string = `${config.API_URL}/${request.tenantId}/odata/Organizers('${request.orgId}')/Setting`;

    return this.http
      .get(url)
      .then((response: AxiosResponse) => {
        return new HttpResponse<SettingResponseModel>(
          response,
          SettingResponseModel
        );
      })
      .catch(
        (error) =>
          new HttpResponse<SettingResponseModel>(
            error?.response,
            SettingResponseModel
          )
      );
  }
}
